import React from "react";
import Stepper from "./Stepper/Stepper";
import { EmploymentInformation } from "../pages/protector/disability/SubForms/EmploymentInformation/EmploymentInformation";
import { MedicalInformation } from "../pages/protector/disability/SubForms/MedicalInformation/MedicalInfromation";
import MedicalHistory from "../pages/protector/disability/SubForms/MedicalHistory/MedicalHistory";
import AssetsAndLiabilities from "../pages/protector/disability/SubForms/AssetsAndLiabilities/AssetsAndLiabilities";
import LegalDocuments from "../pages/protector/disability/SubForms/LegalDocuments/LegalDocuments";
import PrimaryCaregivers from "../pages/protector/disability/SubForms/PrimaryCaregivers/PrimaryCaregivers";
import HomeModification from "../pages/protector/disability/SubForms/HomeModification/HomeModification";
import EquipmentNeed from "../pages/protector/disability/SubForms/EquipmentNeeds/EquipmentNeed";
import Budget from "../pages/protector/disability/SubForms/Budget/Budget";
import ProfessionalContacts from "../pages/protector/disability/SubForms/ProfessionalContacts/ProfessionalContacts";
import DailyLivingPreferences from "../pages/protector/disability/SubForms/DailyLivingPreference/DailyLivingPreferences";
import TreatmentPreferences from "../pages/protector/disability/SubForms/TreatmentPreferences/TreatmentPreferences";
import PersonalFamilyInformation from "../pages/protector/disaster/SubForms/PersonalFamilyInformation/PersonalFamilyInformation";
import EmergencyContacts from "../pages/protector/disaster/SubForms/EmergencyContacts/EmergencyContacts";
import PropertyDocumentation from "../pages/protector/disaster/SubForms/PropertyDocumentation/PropertyDocumentation";
import FinancialDocumentation from "../pages/protector/disaster/SubForms/FinancialDocumentation/FinancialDocumentation";
import ImportantDocumentStorage from "../pages/protector/disaster/SubForms/ImportantDocumentStorage/ImportantDocumentStorage";
import EmergerncySuppliesDocumentation from "../pages/protector/disaster/SubForms/EmergencySuppliesDocumentation/EmergerncySuppliesDocumentation";
import EvacuationPlanning from "../pages/protector/disaster/SubForms/EvacuationPlanning/EvacuationPlanning";
import HomeSafetyAndSecurity from "../pages/protector/disaster/SubForms/HomeSafetyAndSecurity/HomeSafetyAndSecurity";
import CommunicationPlan from "../pages/protector/disaster/SubForms/CommunicationPlan/CommunicationPlan";
import InsuranceCoverage from "../pages/protector/disaster/SubForms/InsuranceCoverage/InsuranceCoverage";
import RecoveryPlan from "../pages/protector/disaster/SubForms/RecoveryPlan/RecoveryPlan";
export default function DisasterStepper() {
  const mysteps = [
    {
      step: "1",
      name: "Personal & Family Information",
    },
    {
      step: "2",
      name: "Emergency Contacts",
    },
    {
      step: "3",
      name: "Property Documentation",
    },
    {
      step: "4",
      name: "Financial Documentation",
    },
    {
      step: "5",
      name: "Important Documents Storage",
    },
    {
      step: "6",
      name: "Emergency Supplies Inventory",
    },
    {
      step: "7",
      name: "Evacuation Planning",
    },
    {
      step: "8",
      name: "Home Safety & Security",
    },
    {
      step: "9",
      name: "Communication Plan",
    },
    {
      step: "10",
      name: "Insurance Coverage",
    },
    {
      step: "11",
      name: "Recovery Plan",
    },
    {
      step: "12",
      name: "Business Continuty (if applicable)",
    },
  ];

  const contentComponents = [
    PersonalFamilyInformation,
    EmergencyContacts,
    PropertyDocumentation,
    FinancialDocumentation,
    ImportantDocumentStorage,
    EmergerncySuppliesDocumentation,
    EvacuationPlanning,
    HomeSafetyAndSecurity,
    CommunicationPlan,
    InsuranceCoverage,
    RecoveryPlan,
    DailyLivingPreferences,
  ];

  return (
    <>
      <Stepper steps={mysteps} contentComponents={contentComponents} />
    </>
  );
}
